import { useCallback, useState } from "react";
import AreYouSureModal from "../components/common/Modals/AreYouSureModal";
import { deleteNotification } from "../utils/useNotification";

interface Options {
  /** api/*Api.tsx içindeki delete fonksiyonu */
  deleteFn: (params: { id: string }) => Promise<any>;
  /** Silme sonrası listeyi tazelemek için */
  onDeleted: () => void;
  /** Hedefe göre değişebilsin diye fonksiyon da verilebilir (ör. pasife al / kalıcı sil). */
  title: string | ((target: any) => string);
  text: string | ((target: any) => string);
  confirmButtonText?: string;
  cancelButtonText?: string;
}

/**
 * "Sil butonuna bas → onay modalı → sil → bildirim → listeyi tazele" akışını sarar.
 * Daha önce her tabloda openDeleteModal/itemToDeleted state'i ve modal JSX'i
 * birebir kopyalanmıştı.
 */
export const useDeleteWithConfirm = ({
  deleteFn,
  onDeleted,
  title,
  text,
  confirmButtonText = "Sil",
  cancelButtonText = "Vazgeç",
}: Options) => {
  const [opened, setOpened] = useState(false);
  const [target, setTarget] = useState<any>(null);

  const askDelete = useCallback((item: any) => {
    setTarget(item);
    setOpened(true);
  }, []);

  const confirm = useCallback(async () => {
    if (!target?._id) return;
    try {
      const { data }: any = await deleteFn({ id: target._id });
      deleteNotification(data?.success, data?.message);
      onDeleted();
    } catch (error) {
      console.error("Silme işlemi başarısız:", error);
      deleteNotification(false);
    } finally {
      setTarget(null);
    }
  }, [deleteFn, onDeleted, target]);

  const modal = (
    <AreYouSureModal
      opened={opened}
      setOpened={setOpened}
      proccessFunc={confirm}
      title={typeof title === "function" ? title(target) : title}
      text={typeof text === "function" ? text(target) : text}
      confirmButtonText={confirmButtonText}
      cancelButtonText={cancelButtonText}
    />
  );

  return { askDelete, modal, target };
};
